import styled from '../../utils/styled'

export const Separator = styled('hr')`
  height: 1px;
  background-color: ${props => props.theme.colors.background};
  border: none;
`
